var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.134,
    height: 102.24,
    viewBox: "0 0 92.134 102.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.86,
    y1: -0.035,
    x2: 1.592,
    y2: 0.709,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#535353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset_1",
    "data-name": "Asset 1",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1.38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(0 1.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M127.19,123.134c.026.207.06.453.091.656a.134.134,0,0,0,.008.038c-.041-.3-.072-.524-.094-.7Z",
    transform: "translate(-79.742 -77.991)",
    fill: "#f04957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M127.093,122.44c-.06-.434-.094-.683,0,0Z",
    transform: "translate(-79.646 -77.297)",
    fill: "#f04957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M127.5,125.323c0-.045-.019-.147-.045-.332v-.011c.023.162.038.287.045.343Z",
    transform: "translate(-79.904 -79.143)",
    fill: "#f04957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M127.45,124.991v-.011h0Z",
    transform: "translate(-79.904 -79.143)",
    fill: "#f04957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M127.428,124.918a.217.217,0,0,0-.008-.038.134.134,0,0,0,.008.038Z",
    transform: "translate(-79.886 -79.081)",
    fill: "#f04957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M85.536,11.254a54.265,54.265,0,0,0,3.27-5.076A15.616,15.616,0,0,0,86.343,3.44c-1.561,1.071-3.032,4.511-4.043,7.252l1.241.566s1.271.713,2,0Z",
    transform: "translate(-51.782 -3.44)",
    fill: "#f04957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M46.154,80.068c-2.945,0-5.355-2.795-5.355-6.208V39.978c-2.855,1.486-5.457,3.077-5.457,3.077V26.19s3.934-5.8,5.457-10.639V9.377A9.276,9.276,0,0,0,37.785,3.86a1.323,1.323,0,0,0-1.7.015A14.8,14.8,0,0,1,38.4,6.492a50.69,50.69,0,0,1-3.077,4.85c-.683.683-1.878,0-1.878,0L32.279,10.8c-.622,1.716-.468,1.392-.622,1.716C29.4,17.207,24.8,16.6,24.472,21.7c-.419,6.419-7.245,17.2-5.608,22.753,1.524,5.155.392,10.752.336,16.062-.015,1.441-1.124,3.526-1.094,4.56C15.549,67.958,1.38,76.817,1.38,76.817L17.9,103s16.673-12.709,24.65-14.271c12.125-2.376,15.119-6.008,18.163-8.663H46.154Z",
    transform: "translate(-1.38 -3.513)",
    fill: "none",
    stroke: "#f04957",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    transform: "translate(81.993 15.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M219.755,151.68a2.955,2.955,0,0,0-.965.17v8.78a2.937,2.937,0,0,0,.965.17c2.248,0,5.1-2.044,5.1-4.56S222,151.68,219.755,151.68Z",
    transform: "translate(-218.79 -110.023)",
    fill: "none",
    stroke: "#f04957",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M220.095,121.71a2.5,2.5,0,0,0-1.3.355v9.726a2.47,2.47,0,0,0,1.3.358,5.221,5.221,0,0,0,0-10.439Z",
    transform: "translate(-218.79 -91.356)",
    fill: "none",
    stroke: "#f04957",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M223.391,41.343a8.038,8.038,0,0,0-4.6.588V52.242c3.967.113,6.57-3.869,7.592-7.335C227.211,42.093,223.391,41.343,223.391,41.343Z",
    transform: "translate(-218.79 -41.224)",
    fill: "none",
    stroke: "#f04957",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M224.507,90.942c-1.931-2.044-4.963-.554-5.717-.132v10.869c.49-.219,1.03-.46,1.652-.732C226.114,98.429,228.611,95.279,224.507,90.942Z",
    transform: "translate(-218.79 -71.536)",
    fill: "none",
    stroke: "#f04957",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(39.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M148.475,71.648c0,3.413-2.41,6.208-5.355,6.208H111.255c-2.945,0-5.355-2.795-5.355-6.208V6.2c0-3.413,2.41-6.2,5.355-6.2H143.12c2.945,0,5.355,2.791,5.355,6.2Z",
    transform: "translate(-105.9)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M173.409,0H154.53l2.5,8.033h18.216v30.59l3.519,11.3V6.2C178.765,2.791,176.355,0,173.409,0Z",
    transform: "translate(-136.19)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 35.538,
    height: 61.782,
    transform: "translate(3.519 8.033)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    transform: "translate(15.768 1.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M160.008,6.4a.915.915,0,0,1-.845.977h-9.919A.915.915,0,0,1,148.4,6.4h0a.917.917,0,0,1,.845-.977h9.919a.917.917,0,0,1,.845.977Z",
    transform: "translate(-148.14 -5.156)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M158.737,7.2h-9.919a1.183,1.183,0,0,1-1.109-1.241,1.183,1.183,0,0,1,1.109-1.241h9.919a1.183,1.183,0,0,1,1.109,1.241A1.183,1.183,0,0,1,158.737,7.2Zm-9.919-1.954a.655.655,0,0,0-.577.713.658.658,0,0,0,.577.713h9.919a.655.655,0,0,0,.577-.713.658.658,0,0,0-.577-.713Z",
    transform: "translate(-147.71 -4.72)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 15.791,
    height: 4.235,
    rx: 2.118,
    transform: "translate(45.464 12.894)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 18.68,
    height: 4.235,
    rx: 2.118,
    transform: "translate(45.464 31.785)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 9.987,
    height: 4.235,
    rx: 2.118,
    transform: "translate(45.464 36.809)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 22.481,
    height: 4.235,
    rx: 2.118,
    transform: "translate(54.085 18.936)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 14.539,
    height: 4.235,
    rx: 2.118,
    transform: "translate(62.024 24.012)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 15.791,
    height: 4.235,
    rx: 2.118,
    transform: "translate(45.464 42.714)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 22.481,
    height: 4.235,
    rx: 2.118,
    transform: "translate(54.085 48.756)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 14.539,
    height: 4.235,
    rx: 2.118,
    transform: "translate(62.024 53.832)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 2.961,
    cy: 2.961,
    r: 2.961,
    transform: "translate(57.747 61.764)",
    fill: "none",
    stroke: "#d3d3d3",
    strokeWidth: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullService);
export default __webpack_public_path__ + "static/media/full-service.296d7c77d899b9825eeadc81af72bd6f.svg";
export { ForwardRef as ReactComponent };